import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setPrompts, setLoading, setError } from '../../../store/prompt/slice';
import { getAllPrompts } from '../../../api/promptApi';
import PromptCard from './components/PromptCard';
import TagFilter, { useFilteredPrompts } from './components/TagFilter';
import Button from '../../../components/UI/Button';
import Modal from '../../../components/UI/Modal';
import PromptForm from './components/PromptForm';
import styles from './PromptsPage.module.scss';

const PromptsPage: React.FC = () => {
  const dispatch = useDispatch();
  const { selectedTag, isLoading, error } = useSelector((state: RootState) => state.prompt);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const filteredPrompts = useFilteredPrompts();

  useEffect(() => {
    const fetchPrompts = async () => {
      try {
        dispatch(setLoading(true));
        const data = await getAllPrompts();
        dispatch(setPrompts(data));
        dispatch(setError(null));
      } catch (err) {
        dispatch(setError(err instanceof Error ? err.message : 'Failed to fetch prompts'));
      } finally {
        dispatch(setLoading(false));
      }
    };

    fetchPrompts();
  }, []);

  if (isLoading) {
    return <div className={styles.loadingContainer}>Loading...</div>;
  }

  if (error) {
    return <div className={styles.errorContainer}>Error: {error}</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Prompts</h1>
        <Button onClick={() => setIsCreateModalOpen(true)}>Create New Prompt</Button>
      </div>
      <TagFilter />
      <div className={styles.grid}>
        {filteredPrompts.map((prompt) => (
          <PromptCard key={prompt.id} prompt={prompt} />
        ))}
      </div>
      {filteredPrompts.length === 0 && (
        <div className={styles.emptyState}>
          No prompts found{selectedTag ? ` for tag "${selectedTag}"` : ''}.
        </div>
      )}

      <Modal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        title="Create New Prompt"
        size="medium"
      >
        <PromptForm mode="create" onSubmit={() => setIsCreateModalOpen(false)} />
      </Modal>
    </div>
  );
};

export default PromptsPage;
